// removed by extract-text-webpack-plugin
module.exports = {"carousel":"_3CYQ8PhZNrPTW4NjFtEu_8","Carousel_side":"CKmeebrMQnkXoK04eal4e","Carousel_side_right":"_1j_IdwpURu_jsu9oAsNhNM","dotsClass":"_3NFOX1qy30zkc8IRU2Y7Zm","slick-active":"_34w4MvFLhdjJ92a1z8tg6G"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyCarousel/Home.scss
 ** module id = 395
 ** module chunks = 0
 **/